const { useEffect } = require("react");
const { default: useLocalStorage } = require("./useLocalStorage");

const useColorMode = () => {
	const [colorMode, setColorMode] = useLocalStorage("color-mode", "light");

	useEffect(() => {
		const className = "dark";
		const bodyClassList = document.body.classList;

		colorMode === "dark"
			? bodyClassList.add(className)
			: bodyClassList.remove(className);
	}, [colorMode]);

	return [colorMode, setColorMode];
};

export default useColorMode;
